import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./../../Shared/Navbar";
import axios from "axios";
import { baseUrl } from "./../../Apiurls/Apiurls";
import ReusableTable from "../../Layout/ReusableTable";

const ViewEmployee = () => {
    const [employees, setEmployees] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const navigate = useNavigate();

    // Fetch employees
useEffect(() => {
    const fetchEmployees = async () => {
        try {
            const res = await axios.get(`${baseUrl}/employees`);
            
            // Filter employees where role is NOT Admin
            const nonAdminEmployees = res.data.filter(emp => emp.role !== "Admin");

            setEmployees(nonAdminEmployees);
            setFilteredData(nonAdminEmployees);
        } catch (err) {
            console.error("Failed to fetch employees:", err);
        }
    };
    fetchEmployees();
}, []);


    // Delete employee
    const handleDelete = async (id) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this employee?");
        if (!confirmDelete) return;

        try {
            await axios.delete(`${baseUrl}/api/employees/${id}`);
            const updated = employees.filter((emp) => emp.id !== id);
            setEmployees(updated);
            setFilteredData(updated);
            alert("Employee deleted successfully");
        } catch (err) {
            console.error("Failed to delete:", err);
            alert("Error deleting employee");
        }
    };

    // Table columns
    const columns = [
        { key: "name", title: "Name" },
        { key: "email", title: "Email" },
        {key: "password", title: "Password" },
        { key: "mobile", title: "Mobile" },
        { key: "role", title: "Role" },

        {
            key: "created_at",
            title: "Created At",
            render: (row) => {
                if (!row.created_at) return "-";
                const d = new Date(row.created_at);
                return d.toLocaleDateString("en-GB");
            },
        },

        {
            key: "actions",
            title: "Actions",
            render: (row) => (
                <div className="d-flex gap-2">
                    <button
                        className="btn btn-primary btn-sm"
                        onClick={() => navigate(`/edit-employee/${row.id}`)}
                    >
                        Edit
                    </button>

                    <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDelete(row.id)}
                    >
                        Delete
                    </button>
                </div>
            ),
        },
    ];

    return (
        <div className="addemployee-container-fluid">
            <div className="addemployee-row">

                <div className="col-md-2">
                    <Navbar />
                </div>

                <div className="addemployee-main col-md-10" style={{ marginTop: "50px" }}>

                    {/* 🔥 Add Employee Button Row */}
                    <div
                        className="d-flex justify-content-end"
                        style={{ marginTop: "20px", marginRight: "20px" }}
                    >
                        <button
                            className="btn btn-success"
                            onClick={() => navigate("/addEmployee")}
                        >
                            + Add Employee
                        </button>
                    </div>


                    <div className="table-container p-3" style={{ marginTop: "20px" }}>
                        <h4 className="mb-3" style={{ fontWeight: "600" }}>
                            Employee Details
                        </h4>

                        <ReusableTable
                            data={filteredData}
                            columns={columns}
                            initialEntriesPerPage={5}
                            searchPlaceholder="Search employees..."
                        />
                    </div>

                </div>

            </div>
        </div>
    );
};

export default ViewEmployee;
